import axios from 'axios'
import Vue from 'vue'
// import { Toast } from 'vant'
// import store from '@/store/index'
// import { generateUUID } from '@/utils/common'
import { getFingerprint } from '@/utils/common'

import router from '../router' // 引入路由
// 创建 axios 实例，将来对创建出来的实例，进行自定义配置
// 好处：不会污染原始的 axios 实例
const instance = axios.create({
  // 基地址
  baseURL: window.location.origin.includes('192.168')
    ? 'http://192.168.110.102:18082/a/'
    : window.location.origin + '/a/',
  // baseURL: 'https://ot.game/a/',
  //   超时时间
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json' // 默认请求头
  },
  params: {
    lang: localStorage.getItem('defaultLanguage') || 'en'
  },
  transformRequest: [
    (data, headers) => {
      // 检测是否为 POST 请求
      if (headers['Content-Type'] === 'application/json') {
        // console.log(window.fingerprint, '-')
        // 获取指纹（异步操作）
        // 添加固定参数
        data = {
          mode: 2, // 固定模式
          code: 2,
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone, //客户端时区
          platform: localStorage.getItem('platform') || 'Otbet', //平台名称
          uuid: window.fingerprint || '', // 客户端的uuid ，网页端要自己生成
          online: true, //是否在线
          currency: localStorage.getItem('currency') || 'NGN', //币种
          isWap: true, //是否手机端
          ...data // 合并用户传入的数据
        }
      }
      return JSON.stringify(data) // 返回 JSON 格式的请求体
    }
  ]
})

// 自定义配置  -- 请求/响应 拦截器
// 添加请求拦截器

// 请求拦截器
instance.interceptors.request.use(
  async (config) => {
    // 开启loading，禁止背景点击(节流处理，多次点击无效)
    // Toast.loading({
    //   message: '加载中...',
    //   forbidClick: true, // 是否禁止背景点击
    //   loadingType: 'spinner',
    //   duration: 0 // 展示时长(ms)，值为 0 时，toast 不会消失
    // })
    // 如果指纹尚未获取，调用 getFingerprint 方法
    if (!window.fingerprint) {
      window.fingerprint = await getFingerprint()
    }
    // // 在这里可以对请求头进行统一配置，例如添加认证token
    const token = localStorage.getItem('token') // 假设token存储在localStorage中
    if (token) {
      config.headers['X-Access-Token'] = token
    }
    return config
  },
  (error) => {
    // 对请求错误做些什么
    // console.error('请求拦截器错误:', error)
    // setTimeout(() => {
    //   window.location.reload()
    // }, 200)
    return Promise.reject(error)
  }
)

// 响应拦截器
instance.interceptors.response.use(
  (response) => {
    // 对响应数据做点什么
    if (response.data.status === 'need_login') {
      localStorage.removeItem('token')
      const currentPath = router.currentRoute && router.currentRoute.path
      // 停留在当前页直接弹登录的场景：activity、home
      const stayInPlace =
        currentPath && (currentPath.includes('/activity') || currentPath.includes('/home'))
      if (stayInPlace) {
        // 通过全局事件总线触发登录弹窗（layout/index.vue 监听）
        if (Vue.prototype.$bus) Vue.prototype.$bus.$emit('openLogin')
      } else {
        router
          .push('/' + localStorage.getItem('country') + '/home')
          .catch((err) => {
            if (err.name !== 'NavigationDuplicated') {
              throw err
            }
          })
      }
    }
    return response.data // 直接返回响应数据
  },
  (error) => {
    // 对响应错误做点什么
    // console.error('响应拦截器错误:', error)
    // if (error.response) {
    //   // 根据响应状态码进行处理
    //   switch (error.response.status) {
    //     case 401:
    //       console.error('未授权')
    //       break
    //     case 403:
    //       console.error('禁止访问')
    //       break
    //     case 404:
    //       console.error('资源未找到')
    //       break
    //     case 500:
    //       console.error('服务器内部错误')
    //       break
    //     default:
    //       console.error('未知错误')
    //   }
    // }
    // setTimeout(() => {
    //   window.location.reload()
    // }, 200)
    return Promise.reject(error)
  }
)

// 导出配置好的实例
export default instance
